module.exports = __webpack_public_path__ + "images/howtouse/user_icon_53e13e7aa21786a515d8eba8f00b8f47.jpg";